import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {filter, map, take, tap} from 'rxjs/operators';
import * as fromAuth from '../reducers';
import * as fromAuthReducer from '../reducers/auth.reducer';
import * as AuthActions from '../actions/user.actions';

export abstract class AbstractAuthGuardService implements CanActivate {
    protected abstract store: Store<fromAuth.AuthState>;

    protected determineIsLoggedIn(): Observable<boolean> {
        this.store.dispatch(AuthActions.validateAuthToken());

        return this.store.pipe(
            select(fromAuth.selectAuthUserState),
            tap((authUserState: fromAuthReducer.State) =>
                console.log('isLoggedIn, isPending', authUserState.isLoggedIn, authUserState.isPending)),
            filter((authUserState: fromAuthReducer.State) => !authUserState.isPending),
            map((authUserState: fromAuthReducer.State) => authUserState.isLoggedIn),
            take(1)
        );
    }

    abstract canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean;
}
